
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Styles from "../../styles/preview/rest.module.scss";
import { getScheduleGym } from "../../services";
import { useDispatch, useSelector } from "react-redux";
import { adminRoutes } from "../../routers/AdminRouters";
import { updateIsPlayingState, updateProgressState } from "../../redux";
import { io } from "socket.io-client";
import { ApiEndpoints, LocalStorageKeys } from "../../core";
function secondsToHhmmss(totalSeconds) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds]
    .map((unit) => String(unit).padStart(2, "0"))
    .join(":");
}

const Rest = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { gymSchedule } = useSelector((state) => state.schedule);
  const [currentDate] = useState(new Date());
  const [socket, setSocket] = useState(null);
  const dispatch = useDispatch();

  const formatIndex = location.state?.formatIndex ?? 0;

  const todaySchedule = gymSchedule?.find((schedule) => {
    const scheduleDate = new Date(schedule.date);
    return scheduleDate.toDateString() === currentDate.toDateString();
  });

  const currentFormat = todaySchedule?.session?.formats?.[formatIndex];


  const restTime = currentFormat?.restTime || 0;
  const restDetails =
    currentFormat?.restPeriodDetails || "No Rest Period Details Available";

  const [remainingRestTime, setRemainingRestTime] = useState(restTime);

  useEffect(() => {
    setRemainingRestTime(restTime);
  }, [restTime]);
  useEffect(() => {
    if (!todaySchedule) return;
    const sessionId = todaySchedule._id;
    const gymToken = localStorage.getItem(LocalStorageKeys.gymToken);
    if (!gymToken) {
      console.error("Token not found in local storage");
      return;
    }
    const socketInstance = io(ApiEndpoints.serverURL, {
      reconnectionDelayMax: 10000,
      auth: {
        token: `Bearer ${gymToken}`,
      },
    });

    setSocket(socketInstance);


    socketInstance.on("preview_control_status", (data) => {
      console.log("Preview Control Status:", data);

      if (data.status === "play") {
        dispatch(updateIsPlayingState({ sessionId, isPlaying: true }));
      } else if (data.status === "pause") {
        dispatch(updateIsPlayingState({ sessionId, isPlaying: false }));
      }
    });

    return () => {
      socketInstance.off("preview_control_status");
      socketInstance.disconnect();
    };
  }, [todaySchedule, dispatch]);
  useEffect(() => {
    if (remainingRestTime <= 0) {
      handleRestComplete();
      return;
    }

    const intervalId = setInterval(() => {
      setRemainingRestTime((prev) => {
        if (prev <= 1) {
          clearInterval(intervalId);
          handleRestComplete();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [remainingRestTime]);

  const handleRestComplete = () => {
    const nextFormatIndex = formatIndex + 1;
    if (todaySchedule?.session?.formats?.length > nextFormatIndex) {
      navigate(adminRoutes.video, { state: { formatIndex: nextFormatIndex } });
    } 
  };

  useEffect(() => {
    getScheduleGym();
  }, []);

  return (
    <div className={Styles.rest_container}>
      <h1 className={Styles.title}>
        {todaySchedule ? todaySchedule.session.name : "No Session Today"}
      </h1>
      <div className={Styles.sub_text}>Continuous work</div>

      <div className={Styles.timer_section}>
        <p className={Styles.timer_label}>Rest Time</p>
        <div className={Styles.timer_display}>
          {secondsToHhmmss(remainingRestTime)}
        </div>
      </div>

      <div className={Styles.info_section}>
        <div
          className={Styles.info_content}
          dangerouslySetInnerHTML={{ __html: restDetails }}
        />
      </div>
    </div>
  );
};

export default Rest;
